module.exports = __webpack_public_path__ + "assets/images/test/sample-ageing-desktop.png?v=66b8f496";